






























import { computed, ComputedRef, defineComponent, Ref, ref } from '@vue/composition-api';
import ObjectId from 'bson-objectid';
import DepthsForm from '@/components/forms/DepthsForm/DepthsForm.vue';
import { SamplingCollection, SoDepth } from '@/store/types';

function createSamplingCollection({
	id,
	fieldId,
	locationCollectionId,
	sampleDepths,
}: {
	id: string;
	fieldId: string;
	locationCollectionId: string;
	sampleDepths: SoDepth[];
}): SamplingCollection {
	const minDepth = 0;
	const maxDepth = sampleDepths.reduce((r: number, x: SoDepth) => {
		const sorted = Object.values(x)
			.map((y) => y.value)
			.sort();
		const max = sorted[sorted.length - 1];
		return max > r ? max : r;
	}, 0);
	const soDepth = {
		minValue: {
			value: minDepth,
			unit: 'unit:CM',
		},
		maxValue: {
			value: maxDepth,
			unit: 'unit:CM',
		},
	};
	return {
		id,
		name: 'Sampling Collection',
		object: locationCollectionId,
		featureOfInterest: fieldId,
		members: [],
		soDepth,
		sampleDepths,
		dateCreated: new Date().toISOString(),
		dateModified: new Date().toISOString(),
	};
}

export default defineComponent({
	components: {
		DepthsForm,
	},
	setup(props, { root }) {
		const hasError = ref(false);
		const isReady = ref(false);

		const fieldId = root.$route.query.field as string;
		const locationCollectionId = root.$route.query.object as string;
		if (!fieldId || !locationCollectionId) {
			hasError.value = true;
		}

		const depths: Ref<SoDepth[]> = ref([
			{
				minValue: {
					value: 0,
					unit: 'unit:CM',
				},
				maxValue: {
					value: 0,
					unit: 'unit:CM',
				},
			},
		]);
		function onSetDepths(value: SoDepth[]) {
			depths.value = value;
		}

		function depthsIsValid(items: SoDepth[]): boolean | string {
			if (!items.length) {
				return 'Must include at least one sample depth';
			}

			if (items.some((d) => d.minValue.value >= d.maxValue.value)) {
				return 'Max depth must be greater than min depth';
			}

			return true;
		}
		// const errors: Ref<string[]> = ref([]);
		const errors: ComputedRef<string | false | null> = computed(() => {
			const result = depthsIsValid(depths.value);
			return result !== true ? result : null;
		});

		async function startClickHandler() {
			if (depthsIsValid(depths.value) === true) {
				const id = new ObjectId().toHexString();
				const newRecord = createSamplingCollection({
					id,
					fieldId: fieldId || '',
					locationCollectionId: locationCollectionId || '',
					sampleDepths: depths.value,
				});
				await root.$store.dispatch('samplingCollections/setRecord', newRecord);
				root.$router.push(`/sampling-collection/${id}/create`);
			}
		}

		isReady.value = true;

		return {
			hasError,
			isReady,
			fieldId,
			locationCollectionId,
			startClickHandler,
			depths,
			onSetDepths,
			errors,
		};
	},
});
